import { render } from "./RadioButtonGroup.vue?vue&type=template&id=544a1766"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=ts"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script